//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('receivables', {
//        templateUrl: 'views/components/views/receivables/receivables.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'utilityService', 'modalService', 'translateService', 'receivablesService', 'logisticService', 'ttGridFactory', 'rememberService', function (stateService, utilityService, modalService, translateService, receivablesService, logisticService, ttGridFactory, rememberService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            let variableNames = {
//                businessco_no: '',
//                date_fom: '',
//                date_tom: '',
//                dateselector_index: '',
//                bg_receivables_main: ''
//            };

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                bgReceivablesMain: {
//                    selected: 'ALL',
//                    buttons: [
//                        { id: 'ALL', label: 'bg_receivables_main_all', color: 'primary', onClick: () => setReceivablesMainView('ALL') },
//                        { id: 'NOT_BOOKED', label: 'bg_receivables_main_not_booked', color: 'primary', onClick: () => setReceivablesMainView('NOT_BOOKED') },
//                        { id: 'BOOKED', label: 'bg_receivables_main_booked', color: 'primary', onClick: () => setReceivablesMainView('BOOKED') }
//                    ]
//                },
//                setting: {},
//                selectListCompanies: [],
//                gridReady: false,
//                getting: false
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_receivables_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            }).setToolbar({ wrapping: true });

//            // #endregion VARIABLES & DEFINITIONS

//            // #region BUTTON GROUP SINGLE FUNCTION

//            function setReceivablesMainView(id) {
//                vm.model.bgReceivablesMain.selected = vm.model.setting.bg_receivables_main = id;

//                rememberFunc('bg_receivables_main');
//                loadGrid();
//            }

//            // #endregion BUTTON GROUP SINGLE FUNCTION

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await receivablesService.getSetting())[0];
//            }

//            async function loadCompanies() {
//                vm.model.selectListCompanies = await logisticService.listCompanies();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                vm.grid.dataTask.loadData = {
//                    method: 3006,
//                    parameters: vm.model.setting
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'businessco_no':
//                    case 'date_fom':
//                    case 'date_tom':
//                    case 'dateselector_index':
//                    case 'bg_receivables_main':
//                        if (utilityService.validateParmsValue(vm.model.setting[id]) !== true) return;

//                        variableValue = vm.model.setting[id];
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }
            
//            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS
            
//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.getChanges = function () {
//                vm.model.getting = true;

//                receivablesService.getTransactions(vm.model.setting).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.getting = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.getting = false;
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region FIELD DATE RANGE CHANGE FUNCTION

//            vm.onDateRangeChanged = function (startDate, endDate, dateInterval) {
//                vm.model.setting.date_fom = startDate;
//                vm.model.setting.date_tom = endDate;
//                vm.model.setting.dateselector_index = +dateInterval <= 0 ? vm.model.setting.dateselector_index : dateInterval;

//                if (vm.model.setting.date_fom) rememberFunc('date_fom');
//                if (vm.model.setting.date_tom) rememberFunc('date_tom');
//                if (vm.model.setting.dateselector_index) rememberFunc('dateselector_index');

//                if (vm.model.setting.date_fom && vm.model.setting.date_tom && vm.model.setting.dateselector_index) {
//                    vm.model.setting.date_fomtom = vm.model.setting.date_fom + vm.model.setting.date_tom;
//                    loadGrid();
//                }
//            }

//            // #endregion FIELD DATE RANGE CHANGE FUNCTION

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'businessco_no':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.businessco_no) !== true) return;

//                        vm.model.setting.businessco_no = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.businessco_no, true) !== true) return;

//                        rememberFunc('businessco_no');
//                        loadGrid();
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                await loadSetting();
//                setReceivablesMainView(vm.model.setting.bg_receivables_main);
//                loadCompanies();
//                loadGrid();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
